<template>
<div>
    <nav class="navbar navbar-default">
        <div class="container-fluid">
            <!-- Brand and toggle get grouped for better mobile display -->

            <!-- Collect the nav links, forms, and other content for toggling -->
            <div class="collapse navbar-collapse margin-left-50-percent" id="bs-example-navbar-collapse-1">
                <ul class="nav navbar-nav ">
                    <li><a class="margin-left-9 " href="/balance.html">{{$t('Balance')}}</a></li>
                    <li><a class="margin-left-9 " href="https://bytetrade.zendesk.com/hc/zh-cn">{{$t('FAQ')}}</a></li>
                
                    <li><a href="/login.html" class="margin-left-24">Log in</a></li>
                    <li>
                        <button onClick="javascript:location.href='/reg.html'" class="btn btn-default bg-green  margin-left-24 height-32 bg-transparent" style="color:#fff;margin-top: 10px;width:80px;">Sign up</button>
                    </li>
                </ul>
            </div>

        </div><!-- /.container-fluid -->
    </nav>
    <div id='LoginForm'>
        <div class="container">

            <h1 class="form-heading text-center" style="margin-top:125px;">{{$t('laststep')}}</h1>
            <div class="login-form" style="margin-top:25px;">
                <div class="main-div">

                    <div id="Login">

                        <div class="form-group">
                            <div class="alert alert-danger" v-if="alertDanger != ''" role="alert">{{alertDanger}}</div>
                            <div class="alert alert-success clear" v-if="alertSuccess != ''" role="alert">{{alertSuccess}}</div>
                            <p class="gray float-left">{{$t('setYourFundPassword')}}</p>

                            <label for="inputPassword" class='green float-left margin-bottom-15 clear' style="margin-top:12px;">{{$t('fundpw')}}</label>

                            <input type="password" @keyup.enter="reg" class="form-control width-320 height-40 margin-bottom-15 border-green" v-model="password" placeholder="">

                        </div>
                        <button @click="reg" class="bg-green btn btn-primary margin-top-24 margin-bottom-24  width-320">{{$t('confirm')}}</button>

                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import settings from '@/utils/settings';

import 'bootstrap';

import $ from 'jquery'
import Utils from '@/utils/Utils';
import axios from '@/service/interceptor';

//import $ from "jquery";
export default {

    data() {
        return {
            lang: Utils.getQueryObject().lang || localStorage.getItem("lang") || 'tr',
            langVal: Utils.getLangVal(Utils.getQueryObject().lang || localStorage.getItem('lang') || 'tr'),
            email: '',
            password: '',
            rePassword: '',
            alertDanger: '',
            alertSuccess: '',
            arrayOfObjects: ['English', '中文'],
            object: {
                name: 'English',
            }
        }
    },
    mounted() {
        // $('.dropdown-toggle').dropdown()
    },
    methods: {
        switchLanguage(lang) {
            // if (lang === this.lang) return false
            location.href = Utils.changeURLArg(location.href, 'lang', lang)
        },
        mounted() {
            $('.dropdown-toggle').dropdown()
        },
        reg() {
            let self = this
            self.alertDanger = ''
            self.alertSuccess = ''
            let query = Utils.getQueryObject(location.href)
            let code = query.code
            let email = query.email
            if (!Utils.isPassword(self.password)) {
                return self.alertDanger = self.$t('passwordWrong')
            }
            if (!code) {
                self.alertDanger = 'Error url'
                return
            }
            axios.post(`${settings.HOST}/api/v1`, {
                "cmd": "register",
                "email": email,
                "capitalPwd": self.password, 
                "code": code 
            }).then(function (data) {
                if (data.data.code == 100013) {
                    return self.alertDanger = self.$t('notSamePassword')
                }

                if (data.data.code == 100009) {
                    self.alertDanger = self.$t('codeErrororExpired')
                    return
                }
                if (data.data.code === 0) {
                    location.href = '/login'
                } else {
                    self.alertDanger = 'Error'
                }
            })
        }
    }
}
</script>
<style scoped>
@import 'bootstrap/dist/css/bootstrap.css';
@import '../../static/style/lib.css';
@import '../../static/style/reg.css';
</style>



// WEBPACK FOOTER //
// src/views/SetFundPassword.vue